import React from 'react'
import { RowDetalleInventario } from './RowDetalleInventario.jsx'

import * as css from '../../FondosAsignados.css'

let PropTypes = React.PropTypes

export class TablaDetalleInventarios extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        let totalInventarios = this.props.inventarios.length
        return (
            <div className={"panel panel-default "+css.panelInventarios}>
                <div className={"panel-heading "+css.panelHeadingDetalle}><b>Inventarios</b></div>
                <div className={"panel-body "+css.panelBodyCustom}>
                    <TablaInventario>
                        {_.range(0, totalInventarios).map(index=>{
                            let inventario = this.props.inventarios[index]
                            return <RowDetalleInventario
                                key={index}
                                index={index}
                                inventario={inventario}
                            />
                        })}
                    </TablaInventario>
                </div>
            </div>
        )
    }
}
let TablaInventario = ({children}) =>
    <table className={"table table-condensed "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colFecha}/>
            <col className={css.colCliente}/>
            <col className={css.colLocal}/>
            <col className={css.colComuna}/>
            <col className={css.colRegion}/>
            <col className={css.colJornada}/>
            <col className={css.colDotacion}/>
            <col className={css.colHrLider}/>
        </colgroup>
        <thead>
        <tr>
            <th className={css.thIndex}>#</th>
            <th className={css.thFecha}>Fecha</th>
            <th className={css.thCliente}>CLI</th>
            <th className={css.thLocal}>Local</th>
            <th className={css.thComuna}>Comuna</th>
            <th className={css.thRegion}>Región</th>
            <th className={css.thJornada}>Jornada</th>
            <th className={css.thDotacion}>Dotación</th>
            <th className={css.thHrLider}>Hr Lider</th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/ruta/TablaDetalleInventarios.jsx